import { render, staticRenderFns } from "./autOrderMana.vue?vue&type=template&id=2a663748&scoped=true&"
import script from "./autOrderMana.vue?vue&type=script&lang=js&"
export * from "./autOrderMana.vue?vue&type=script&lang=js&"
import style0 from "./autOrderMana.vue?vue&type=style&index=0&id=2a663748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a663748",
  null
  
)

export default component.exports